(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("externalQualificationForm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/externalQualifications/externalQualificationFormView.html",
            controller: ["authService", "externalQualificationHistoryResource", "calendarSettingsService", "activationFilesResource", "messageService", "$scope", "$uibModal", "$state", "DTOptionsBuilder", "$translate", "_", "Upload", "$timeout", ExternalQualificationFormCtrl],
            controllerAs: "vm"
        };
        function ExternalQualificationFormCtrl(authService, externalQualificationHistoryResource, calendarSettingsService, activationFilesResource, messageService, $scope, $uibModal, $state, DTOptionsBuilder, $translate, _, Upload, $timeout) {
            var vm = this;
            vm.loading = true;
            vm.isSuperAdmin = authService.isSuperAdmin();
            vm.isUpdate = $state.current.name === "main.evaluations.externalQualificationsEdit";
            vm.isResume = $state.current.name === "main.evaluations.externalQualificationsResume";
            vm.isAdd = $state.current.name === "main.evaluations.externalQualificationsAdd";
            vm.isContinue = false;
            vm.code = $state.params.code;
            vm.person = $state.params.person;
            vm.assignmentId = $state.params.assignmentId;
            vm.activationNumber = $state.params.activationNumber ? $state.params.activationNumber : 0;
            //Files
            if (!vm.externalQualificationFiles)
                vm.externalQualificationFiles = [];
            vm.maxFilesAllowed = 10;
            vm.fileUploadErrors = [];
            vm.showErrors = false;
            //Used to constructSave Data
            vm.activation = {};
            vm.externalQualification = {};
            //Date picker Config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.open = calendarSettingsService.open;
            vm.openSecond = calendarSettingsService.openSecond;
            //Datatable Configuration
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("order", [0, "desc"])
                .withPaginationType("full_numbers")
                .withBootstrap();
            //Default set to false, Add default is true (To init dropzoneFiles Mock)
            vm.showDropZone = false;
            //Load Assignment and Activation Info
            externalQualificationHistoryResource.getHistoryViewModel({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId }, function (data) {
                vm.assignment = data;
            });
            if ($state.params.activationNumber !== undefined && vm.activationNumber > 0 && vm.isUpdate) {
                externalQualificationHistoryResource.getRecord({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: vm.activationNumber }, function (data) {
                    vm.externalQualification = data;
                    if (vm.externalQualification.activationExternalQualification !== null)
                        vm.externalQualification.activationExternalQualification.evaluationDate = new Date(data.activationExternalQualification.evaluationDate);
                    if (data.activationExternalQualification.expiryDate === "0001-01-01T00:00:00")
                        vm.externalQualification.activationExternalQualification.expiryDate = "";
                    else
                        vm.externalQualification.activationExternalQualification.expiryDate = new Date(data.activationExternalQualification.expiryDate);
                    vm.externalQualificationFiles = data.files;
                    vm.activationNumber = data.activationNumber;
                    vm.showDropZone = true;
                    vm.externalQualification.isUpdate = true;
                    vm.loading = false;
                }, function () {
                    $state.go("main.notFound");
                });
            }
            else {
                //Load latest unfinished activation record.
                externalQualificationHistoryResource.getRecent({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId }, function (data) {
                    //If there is an activationNumber then this is a resume state, load the data, else, go to the add page
                    if (!data.activationNumber) {
                        $state.go("main.evaluations.externalQualificationsAdd", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
                    }
                    else {
                        if (!data.completedDate && !vm.isAdd) {
                            vm.activationNumber = data.activationNumber;
                            vm.isContinue = true;
                            vm.externalQualification = data;
                            if (vm.externalQualification.activationExternalQualification !== null) {
                                vm.externalQualification.activationExternalQualification.evaluationDate = new Date(data.activationExternalQualification.evaluationDate);
                                if (data.activationExternalQualification.expiryDate === "0001-01-01T00:00:00")
                                    vm.externalQualification.activationExternalQualification.expiryDate = "";
                                else
                                    vm.externalQualification.activationExternalQualification.expiryDate = new Date(data.activationExternalQualification.expiryDate);
                            }
                            vm.externalQualificationFiles = data.files;
                            vm.activationNumber = data.activationNumber;
                        }
                        else {
                            if (!data.completedDate)
                                $state.go("main.evaluations.externalQualificationsResume", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
                            else
                                $state.go("main.evaluations.externalQualificationsAdd", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
                        }
                    }
                    vm.loading = false;
                });
            }
            //Determines wither to go back to history or manage list pages.
            vm.goBackToActivationList = function () {
                if (vm.assignment.activations.length === 0 || vm.assignment.activations.length === 1 && _.where(vm.assignment.activations, { addedOn: "0001-01-01T00:00:00" }).length > 0) {
                    $state.go("main.evaluations.externalQualifications");
                }
                else {
                    $state.go("main.evaluations.externalQualificationHistory", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
                }
            };
            vm.submitData = function () {
                if (vm.isResume || vm.isUpdate) {
                    vm.externalQualification.activationExternalQualification.id = vm.externalQualification.id;
                }
                else {
                    var formInputData = vm.externalQualification;
                    vm.externalQualification = vm.activation;
                    vm.externalQualification.score = formInputData.score;
                    vm.externalQualification.activationExternalQualification = formInputData.activationExternalQualification;
                    vm.externalQualification.activationExternalQualification.id = vm.externalQualification.id;
                }
                externalQualificationHistoryResource.update({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: vm.activationNumber }, vm.externalQualification, function () {
                    vm.goBackToActivationList();
                }, function (error) {
                    messageService.error(error);
                });
            };
            // Save and update activation record
            vm.saveActivation = function (isValid) {
                if (vm.externalQualificationFiles.length === 0 || vm.externalQualificationFiles.length > vm.maxFilesAllowed) {
                    isValid = false;
                }
                if (vm.isSuperAdmin && vm.isUpdate && vm.activationForm.txtNote === "") {
                    isValid = false;
                }
                if (isValid) {
                    vm.clearError();
                    if (!vm.isUpdate) {
                        var modal = $uibModal.open({
                            templateUrl: "completeActivationConfirmation.html",
                            backdrop: false,
                            animation: false,
                            windowClass: "confirmation-modal"
                        });
                        modal.result.then(function () {
                            vm.submitData();
                        }).catch(angular.noop);
                    }
                    else {
                        vm.submitData();
                    }
                }
                else {
                    vm.showErrors = true;
                }
            };
            //Future Date Validation
            vm.checkDate = calendarSettingsService.checkDate;
            //Remove errors from dropzone list
            vm.clearError = function () {
                vm.fileUploadErrors = [];
            };
            //Delete File from DB and Azure (From Modal)
            vm.deleteFile = function (id, fileUrl) {
                var modal = $uibModal.open({
                    templateUrl: "deleteFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    activationFilesResource.delete({ id: id }, function () {
                        vm.externalQualificationFiles = _.without(vm.externalQualificationFiles, _.find(vm.externalQualificationFiles, { url: fileUrl }));
                        vm.externalQualificationFiles.$valid = vm.externalQualificationFiles.length > 0;
                        vm.invalidFiles = [];
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.upload = function () {
                if (vm.files && vm.files.length) {
                    vm.files.upload = Upload.upload({
                        url: "api/externalQualificationAssignments/" + vm.code + "/" + vm.person + "/" + vm.assignmentId + "/history/" + vm.activationNumber + "/files",
                        data: {
                            files: vm.files
                        }
                    });
                    vm.files.upload.then(function (response) {
                        $timeout(function () {
                            //vm.externalQualificationFiles = vm.externalQualificationFiles.concat(response.data.files);
                            //Multi-Files
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.progress = 0;
                            vm.activation = response.data;
                            if (!vm.activation.activationExternalQualification) {
                                vm.activation.activationExternalQualification = {};
                            }
                            vm.activationNumber = vm.activation.activationNumber;
                            vm.externalQualificationFiles = vm.activation.files;
                            vm.externalQualificationFiles.$valid = true;
                            vm.selectedFiles = [];
                        });
                    }, function (error) {
                        if (error.status > 0) {
                            messageService.error(error);
                            vm.selectedFiles = [];
                        }
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.selectedFiles = []; //Temp array to store the files that the user has selected for upload.
            vm.validateFile = function (file) {
                vm.selectedFiles.push(file);
                if (vm.externalQualificationFiles.length + vm.selectedFiles.length > vm.maxFilesAllowed) {
                    return "maxFiles";
                }
                if (_.includes(_.pluck(vm.externalQualificationFiles, "fileName"), file.name)) {
                    return "sameName";
                }
                return true;
            };
        }
    });
}());
